interface UndoIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function UndoIcon({ color = 'currentColor', ...svgProps }: UndoIconProps) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M3.14645 0.64644C3.34171 0.451191 3.65822 0.451182 3.85348 0.64644C4.0487 0.841701 4.04872 1.15822 3.85348 1.35347L1.70699 3.49996L10.5 3.49996C11.5904 3.49997 12.9544 3.83829 14.0576 4.70015C15.1802 5.57723 16 6.97286 16 8.99996C16 11.0271 15.1802 12.4227 14.0576 13.2998C12.9544 14.1616 11.5904 14.4999 10.5 14.5L5.49996 14.5C5.22383 14.5 4.99997 14.2761 4.99996 14C4.99996 13.7238 5.22382 13.5 5.49996 13.5L10.5 13.5C11.4095 13.4999 12.5456 13.2132 13.4423 12.5127C14.3197 11.8272 15 10.7228 15 8.99996C15 7.27715 14.3197 6.17269 13.4423 5.48726C12.5456 4.7867 11.4095 4.49997 10.5 4.49996L1.70699 4.49996L3.85348 6.64644L3.91793 6.72457C4.04607 6.91864 4.02432 7.18262 3.85348 7.35347C3.68263 7.52432 3.41865 7.54606 3.22457 7.41792L3.14645 7.35347L0.146447 4.35347C-0.0488155 4.15821 -0.0488155 3.8417 0.146447 3.64644L3.14645 0.64644Z"
        fill={color}
      />
    </svg>
  );
}
